/**
 * Normalizes HTTP API error messages (MercatelyModel) to display in toast.
 *
 * @param {Error|Object} error - Error thrown by processRequest
 * @param {string} [fallbackMessage] - Message if the API does not return details
 * @returns {string}
 */
export function getInboxApiErrorMessage(error, fallbackMessage = 'An error occurred') {
  if (!error) {
    return fallbackMessage;
  }

  if (error?.message && error.message !== '[object Object]') {
    return error.message;
  }

  if (typeof error?.errors === 'string') {
    return error.errors;
  }

  if (Array.isArray(error?.errors)) {
    return error.errors.filter(Boolean).join(', ') || fallbackMessage;
  }

  if (error?.errors && typeof error.errors === 'object') {
    const messages = Object.values(error.errors)
      .flatMap((value) => (Array.isArray(value) ? value : [value]))
      .filter(Boolean)
      .map(String);

    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  return fallbackMessage;
}

/**
 * Muestra un toast con el mensaje de error del API.
 *
 * @param {Error|Object} error
 * @param {string} [fallbackMessage]
 * @returns {string} Mensaje mostrado
 */
export function showInboxApiErrorToast(error, fallbackMessage) {
  const message = getInboxApiErrorMessage(error, fallbackMessage);

  if (typeof showtoast === 'function') {
    showtoast(message);
  }

  return message;
}
